import { connect } from 'react-redux';
import { actionCreators } from './actions';
import { HeaderPanelProps } from 'app/components/case-header-panel';
import { ComplexValue } from 'ui';

export const withCallsToActions = (component: any) => {

  const dispatchToProps = (dispatch: any): Partial<HeaderPanelProps> => {
    return {
      callsToActions: (caseId: number) => 
        dispatch(actionCreators.callsToActions(caseId)),
      
      onChangeCaseStatus: (caseId: number, status: ComplexValue<number>, allowWarnings: boolean = true) => 
        dispatch(actionCreators.onChangeCaseStatus(caseId, status, allowWarnings))
    };
  };

  return connect<any, any, any>(undefined, dispatchToProps)(component);
};
